import { NetworkService } from '../../services/networkService';
import { createApiStore } from '../apiStore';

const networkService = new NetworkService();

const fetchData = async (data?: Object): Promise<Object> => {
  const dataMap = data as Record<string, any> | undefined;
  const username = dataMap?.username as string | undefined;
  const category = dataMap?.category as string | undefined;
  return await networkService.getGenealogy(username, category);
};

export const useGenealogyStore = createApiStore(fetchData);
